// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-app {
    display: flex;
    justify-content: center;
}
ul.navbar-nav.bars-menu {
    float: left;
}

.logo-app img {
    width: 200px;
    margin-bottom: 3px;
    /* margin-left: 60px; */
}

.navbar-header-1 {
    width: 350px;
}
.top-header{
    height: 20px;
    background-color: #bd0000;
}
.main-header {
    margin-top: 8px;
    background-color: #ffffff;
}
.main-header, .top-header{
    z-index: 1000;
    /* z-index: 1039; */
    /* z-index: 1999; */
    margin-left: 0px!important;
    border: none;
    box-shadow: 0 0.5rem 1rem 0 rgb(44 51 73 / 10%);
    position: fixed;
    width: 100%;
}
.navbar-light .navbar-nav .nav-link {
    /*color: #13608B;*/
    font-weight: 500;
    font-size: 14px;
    font-family: Roboto;
    cursor: pointer;
}
header.main-header.navbar.navbar-expand.navbar-white.navbar-light {
    margin-left: 0 !important;
}
ul.navbar-nav.bars-menu .nav-link {
    margin: 5px;
    float: left;
}

.navbar-brand.logo{
    font-size: 1.75rem;
}
.title-purple{
    color: #d63230;
}
.title-green{
    color: #188431;
}
.btn-logout{
    background: #ae2626;
    color: #fff;
    font-weight: 700;
}

.dropdown-menu.dropdown-menu-lg.dropdown-menu-right.show {
    border-radius: 10px;
    /* padding: 10px; */
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
    border: none;
}
span.rol-user {
    background: #6c757da8;
    float: left;
    width: 100%;
    text-align: center;
    padding: 10px;
    font-size: 13px;
    border-radius: 10px 10px 0px 0;
    color: #fff;
    font-weight: 600;
}
span.email-user {
    float: left;
    width: 100%;
    color: #343a40db;
    padding: 20px 0;
    text-align: center;
    font-size: 13px;
    font-weight: bold;
}

span.salir-user {
    float: left;
    width: 100%;
    text-align: center;
    font-size: 13px;
    background: #ae2626;
    padding: 10px;
    color: #fff;
    border-radius: 0px 0px 10px 10px;
    cursor: pointer;
}
.notifications-header{
    background-color: #EFE71D;
    border-radius: 30px;
}


#menu2 {
    color: black;
}
.form-search {
    margin: 3px 150px;
    width: 500px;
}
.form-search button {
    background-color: #ffffff;
    color: #822FA7;
    border: none;
    cursor: pointer;
    border: 0px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}
.form-search input {
    padding: 20px;
    border: none;
    font-size: 16px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}
#text_acceder::after {
    margin-left: 5px;
    content: 'Acceder | Registro';
}
#text_cerrarSesion::after {
    margin-left: 5px;
    content: 'Cerrar Sesión';
}
@media screen and (max-width: 1440px) {
    .form-search {
        width: 350px;
    }
}
@media screen and (max-width: 1290px) {
    .form-search {
        /* float: left; */
        margin: 3px 50px;
        width: 400px;
    }
    .navbar-header-1 {
        width: 290px;
    }
}
@media screen and (max-width: 1095px) {
    .form-search {
        /* float: left; */
        margin: 3px 20px;
        width: 270px;
    }
    .logo-app img {
        margin-left: 0px;
    }
}
@media screen and (max-width: 800px) {
    #text_cerrarSesion::after {
        margin-left: 0;
        content: '';
    }
}
@media screen and (max-width: 730px) {
    .form-search {
        margin: 3px 10px;
        width: 380px;
    }
    .form-search input {
        font-size: 15px;
    }
    .logo-app img {
        width: 150px;
        margin-top: 3px;
    }
}
@media screen and (max-width: 500px) {
    #text_acceder::after {
        margin-left: 0;
        content: '';
    }
    .hide-mobile{
        display: none!important;
    }
}
@media screen and (max-width: 425px) {
    .logo-app img {
        margin-left: 0;
    }
}
@media screen and (max-width: 375px) {
    .logo-app img {
        width: 120px;
        margin-top: 7px;
    }
    /* .main-header {
        margin-top: 35px;
        height: 8px;
    } */
    .form-search input {
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/appheader/appheader.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;IACZ,+CAA+C;IAC/C,eAAe;IACf,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kDAAkD;IAClD,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,gCAAgC;IAChC,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;;AAGA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,WAAW;IACX,2BAA2B;IAC3B,8BAA8B;IAC9B,6BAA6B;IAC7B,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;AACnC;AACA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,cAAc;QACd,WAAW;IACf;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,eAAe;IACnB;AACJ;AACA;IACI;QACI,cAAc;QACd,WAAW;IACf;IACA;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,YAAY;QACZ,eAAe;IACnB;IACA;;;OAGG;IACH;QACI,eAAe;IACnB;AACJ","sourcesContent":[".logo-app {\n    display: flex;\n    justify-content: center;\n}\nul.navbar-nav.bars-menu {\n    float: left;\n}\n\n.logo-app img {\n    width: 200px;\n    margin-bottom: 3px;\n    /* margin-left: 60px; */\n}\n\n.navbar-header-1 {\n    width: 350px;\n}\n.top-header{\n    height: 20px;\n    background-color: #bd0000;\n}\n.main-header {\n    margin-top: 8px;\n    background-color: #ffffff;\n}\n.main-header, .top-header{\n    z-index: 1000;\n    /* z-index: 1039; */\n    /* z-index: 1999; */\n    margin-left: 0px!important;\n    border: none;\n    box-shadow: 0 0.5rem 1rem 0 rgb(44 51 73 / 10%);\n    position: fixed;\n    width: 100%;\n}\n.navbar-light .navbar-nav .nav-link {\n    /*color: #13608B;*/\n    font-weight: 500;\n    font-size: 14px;\n    font-family: Roboto;\n    cursor: pointer;\n}\nheader.main-header.navbar.navbar-expand.navbar-white.navbar-light {\n    margin-left: 0 !important;\n}\nul.navbar-nav.bars-menu .nav-link {\n    margin: 5px;\n    float: left;\n}\n\n.navbar-brand.logo{\n    font-size: 1.75rem;\n}\n.title-purple{\n    color: #d63230;\n}\n.title-green{\n    color: #188431;\n}\n.btn-logout{\n    background: #ae2626;\n    color: #fff;\n    font-weight: 700;\n}\n\n.dropdown-menu.dropdown-menu-lg.dropdown-menu-right.show {\n    border-radius: 10px;\n    /* padding: 10px; */\n    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;\n    border: none;\n}\nspan.rol-user {\n    background: #6c757da8;\n    float: left;\n    width: 100%;\n    text-align: center;\n    padding: 10px;\n    font-size: 13px;\n    border-radius: 10px 10px 0px 0;\n    color: #fff;\n    font-weight: 600;\n}\nspan.email-user {\n    float: left;\n    width: 100%;\n    color: #343a40db;\n    padding: 20px 0;\n    text-align: center;\n    font-size: 13px;\n    font-weight: bold;\n}\n\nspan.salir-user {\n    float: left;\n    width: 100%;\n    text-align: center;\n    font-size: 13px;\n    background: #ae2626;\n    padding: 10px;\n    color: #fff;\n    border-radius: 0px 0px 10px 10px;\n    cursor: pointer;\n}\n.notifications-header{\n    background-color: #EFE71D;\n    border-radius: 30px;\n}\n\n\n#menu2 {\n    color: black;\n}\n.form-search {\n    margin: 3px 150px;\n    width: 500px;\n}\n.form-search button {\n    background-color: #ffffff;\n    color: #822FA7;\n    border: none;\n    cursor: pointer;\n    border: 0px;\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n.form-search input {\n    padding: 20px;\n    border: none;\n    font-size: 16px;\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n#text_acceder::after {\n    margin-left: 5px;\n    content: 'Acceder | Registro';\n}\n#text_cerrarSesion::after {\n    margin-left: 5px;\n    content: 'Cerrar Sesión';\n}\n@media screen and (max-width: 1440px) {\n    .form-search {\n        width: 350px;\n    }\n}\n@media screen and (max-width: 1290px) {\n    .form-search {\n        /* float: left; */\n        margin: 3px 50px;\n        width: 400px;\n    }\n    .navbar-header-1 {\n        width: 290px;\n    }\n}\n@media screen and (max-width: 1095px) {\n    .form-search {\n        /* float: left; */\n        margin: 3px 20px;\n        width: 270px;\n    }\n    .logo-app img {\n        margin-left: 0px;\n    }\n}\n@media screen and (max-width: 800px) {\n    #text_cerrarSesion::after {\n        margin-left: 0;\n        content: '';\n    }\n}\n@media screen and (max-width: 730px) {\n    .form-search {\n        margin: 3px 10px;\n        width: 380px;\n    }\n    .form-search input {\n        font-size: 15px;\n    }\n    .logo-app img {\n        width: 150px;\n        margin-top: 3px;\n    }\n}\n@media screen and (max-width: 500px) {\n    #text_acceder::after {\n        margin-left: 0;\n        content: '';\n    }\n    .hide-mobile{\n        display: none!important;\n    }\n}\n@media screen and (max-width: 425px) {\n    .logo-app img {\n        margin-left: 0;\n    }\n}\n@media screen and (max-width: 375px) {\n    .logo-app img {\n        width: 120px;\n        margin-top: 7px;\n    }\n    /* .main-header {\n        margin-top: 35px;\n        height: 8px;\n    } */\n    .form-search input {\n        font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
